import { Select, MenuItem } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const menuStyle = {
  '&:hover': {
      backgroundColor: '#D3D3D3',
      color: 'black',
  },
  '&.Mui-selected': {
      backgroundColor: 'grey',
      color: '#fff',
  },
  '&.Mui-selected:hover': {
      backgroundColor: 'grey',
  },

  '&.Mui-focusVisible': {
      backgroundColor: 'grey',
  },
  '&.Mui-selected.Mui-focusVisible': {
      backgroundColor: 'grey',
  },
}

function SelectComponent({ data, value, onChange, disabled }) {
  const options = data?.recommendationOptions || [];
  const safeValue = value !== undefined && value !== null && (value === '' || options.includes(value))
    ? value
    : '';
  return (
    <>
      <Select
        disabled={disabled}
        variant="standard"
        disableUnderline
        value={safeValue}
        onChange={onChange}
        displayEmpty
        IconComponent={KeyboardArrowDownIcon}
        sx={{
          borderRadius: "5px",
          backgroundColor: "#FFF",
          boxShadow: "0 0 0 1px #ddd",
          // px: 2,
          // py: 0.5,
          height: "20px",
          width: "95px",
          fontSize: "11px",
          fontWeight: 500,
          my: 1,
          "& .MuiSelect-select": {
            display: "flex",
            alignItems: "center",
            gap: "6px",
            marginLeft: 1,
          },
          "& fieldset": { border: "none" },
          "& .MuiSelect-icon": {
            fontSize: '18px',
            color: "#869094",
            right: 4,
          },
        }}
      >
        {options.map((opt, index) => {
          return <MenuItem key={index} value={opt} sx={menuStyle}>{opt}</MenuItem>;
        })}
      </Select>
    </>
  );
}

export default SelectComponent;
